import { motion } from "framer-motion";
import XionLogo from "./XionLogo";

export default function MadeByBadge() {
  return (
    <motion.a
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 1.2, duration: 0.6 }}
      href="mailto:baligarvedant@gmail.com"
      data-testid="made-by-badge"
      className="fixed bottom-4 left-4 z-40 inline-flex items-center gap-2 px-3 py-2 rounded-full bg-[#0C0C14]/80 backdrop-blur border border-white/10 hover:border-[#00D4FF]/40 hover:bg-[#00D4FF]/5 transition group shadow-[0_8px_24px_rgba(0,0,0,0.4)]"
      aria-label="Made by Vedant Baligar"
    >
      <XionLogo size={18} />
      <span className="text-[10px] font-mono uppercase tracking-[0.18em] text-slate-300 group-hover:text-white">
        Made by <span className="text-[#00D4FF]">Vedant Baligar</span>
      </span>
    </motion.a>
  );
}
